import React, { useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import ArrowRight from 'theme/icons/arrow-right';
import Text from 'theme/text';

const Button = styled.div`
  width: 320px;
  height: 85px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 0 ${themeGet('space.s')}px;

  background: ${({ isSelected }) =>
    isSelected ? themeGet('colors.primary_100') : themeGet('colors.white')};

  color: ${({ isDisabled }) =>
    isDisabled ? themeGet('colors.grey_200') : themeGet('colors.grey_600')};

  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  & :hover {
    background: ${({ isSelected }) =>
      isSelected ? themeGet('colors.primary_100') : themeGet('colors.primary_50')};
  }

  & > .left {
    display: flex;
    flex-direction: row;
  }

  &:disabled {
    opacity: 0.5;
  }
`;

function SelectorChart({ term, position, selected, disabled, onChange }) {
  const handleChange = useCallback(() => {
    if (!disabled) onChange(position);
  }, [position, onChange]);

  const isSelected = useMemo(() => disabled ? 0 : position === selected, [position, selected]);

  return (
    <Button onClick={handleChange} isSelected={isSelected} isDisabled={disabled}>
      <div className="left">
        <Text fontSize="h3" lineHeight="h2" fontWeight="medium" mr="xxs" color="grey_400">
          Top
        </Text>
        <Text fontSize="h2" lineHeight="h2" fontWeight="bold">
          {term.label}
        </Text>
      </div>

      <div className="right">
        <ArrowRight />
      </div>
    </Button>
  );
}

export default SelectorChart;
